/* eslint-disable */ module.exports = {
  localeData: {
    plurals: function (n, ord) {
      var s = String(n).split('.'),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
      if (ord)
        return n10 == 1 && n100 != 11
          ? 'one'
          : n10 == 2 && n100 != 12
            ? 'two'
            : n10 == 3 && n100 != 13
              ? 'few'
              : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
  },
  messages: {
    '#Contenido': '#Content',
    '#Curso': '#Course',
    '#ID Anterior': '#ID Previous',
    '#Instancia': '#Instance',
    '#Perfil': '#Profile',
    '#Perfil Spac': '#Profile SPAC',
    '#Profile Spac': '#Profile Spac',
    '#ProfileSpac': '#ProfileSpac',
    '#Turno': '#Shift',
    '- Curso sin contenidos -': '-Empty course-',
    '<0>Est\xE1 por empezar el test {0}</0>':
      '<0>The test is about to begin {0}</0>',
    'Abandonar curso': 'Exit course',
    Accept: 'Accept',
    Acciones: 'Actions',
    Activado: 'Activated',
    Actividad: 'Activity',
    Activo: 'Active',
    'Activo en': 'Active in',
    Actualizacion: 'Update',
    'Actualizado por': 'Updated by',
    Add: 'Add',
    AdminHSE: 'AdminHSE',
    AdminITPS: 'AdminITPS',
    AdminQA: 'AdminQA',
    Administrador: 'Administrator',
    Agregar: 'Add',
    'Agregar Asistentes': 'Add Assistants',
    'Agregar requerimientos a cursos': 'Add requirements to courses',
    'Agregar respuesta': 'Add answer',
    Anterior: 'Previous',
    Aprobado: 'Approved',
    Aprobados: 'Approved',
    'Aprobados (%)': 'Approved (%)',
    'Aprob\xF3': 'Approve',
    'Arrastre el PDF ac\xE1 o haga click para seleccionarlos.':
      'Drop PDF here or click to select file',
    'Aseg.Calidad': 'Ensure quality',
    Asistentes: 'Assistant',
    'Asistentes (%)': 'Assistants (%)',
    'Asistentes seleccionados': 'Selected assistants ',
    'Asisti\xF3': 'Assist',
    Attended: 'Attended',
    'Attended does not exist': 'Attended does not exist',
    Attendeds: 'Attendeds',
    'A\xF1adir material': 'Add material',
    'BP Propietario': 'BP Owner',
    Baja: 'Out',
    Bienvenido: 'Welcome',
    CWID: 'CWID',
    Calificacion: 'Calification',
    'Calificaci\xF3n': 'Calification',
    Calificado: 'Qualified',
    Cancel: 'Cancel',
    Cancelada: 'Cancelled',
    Cancelar: 'Cancel',
    'Cantidad total': 'Total count',
    'Capa inicial leg': 'Initial capacitation leg',
    'Capa inicial': 'Initial capacitation',
    'Capacitaciones de todos los colaboradores':
      'Capacitaciones de todos los colaboradores',
    'Capacitación Colaboradores': 'Collaborator training',
    'Capacitaciones pendientes por SPAC': 'Capacitation pending by SPAC',
    'Capacitaciones pendientes por sector': 'Capacitation pending by sector',
    'Capacitaciones pendientes por spac': 'Capacitation pending by spac',
    'Capacitations Pending by SPAC': 'Capacitations pending by SPAC',
    'Capacitations for collaborators': 'Capacitations for collaborators',
    'Capacitations pending by sector': 'Capacitations pending by sector',
    'Cargando...': 'Loading...',
    'Cargar nuevo PDF': 'Load new PDF',
    Categoria: 'Category',
    'Categoria de hardware': 'Category of hardware',
    'Categoria de software': 'Category of software',
    'Cerrar sesi\xF3n': 'Logout',
    Choice: 'Choice',
    'Clonar curso': 'Clone course',
    Colaborador: 'collaborator',
    'Colaborador responsable': 'Responsable collaborator',
    Colaboradores: 'Collaborators',
    'Colaboradores por capacitacion': 'Capacitation by collaborators',
    Collaborator: 'collaborator',
    Collaborators: 'Collaborators',
    'Compa\xF1\xEDa': 'Management',
    Completed: 'Completed',
    Condicion: 'Condition',
    'Condicion colaborador': 'Collaborator condition',
    'Configuracion de los parametros Generales':
      'Configuration of general settings',
    'Confirm operation': 'Confirm operation',
    'Confirmaci\xF3n del curso': 'Course confirmation',
    Confirmar: 'Confirm',
    'Confirmar credenciales': 'Confirm credentials',
    'Confirmar operaci\xF3n': 'Confirm operation',
    Consult: 'Consults',
    'Consulta por mes': 'Consult by month',
    'Consulta por sector': 'Sector consult',
    'Consulta por usuario': 'User consult',
    Consultas: 'Consults',
    Contenido: 'Content',
    Contenidos: 'Contents',
    'Contrase\xF1a': 'Password',
    'Copiar perfil': 'Copy profile',
    Course: 'Course',
    'Course Types': 'Course Types',
    'Course types': 'Course types',
    'CourseType does not exist': 'CourseType does not exist',
    Courses: 'Courses',
    'Creado correctamente': 'Successfully created',
    Crear: 'Create',
    'Crear curso': 'Create course',
    'Crear reporte': 'Create report',
    'Cuestionario N\xB0': 'Questionnaire Number',
    'Cuestionario aprobado exitosamente': 'Questionnaire successfully passed',
    'Cuestionario desaprobado': 'Questionnaire disapproved',
    Curso: 'Course',
    'Curso clonado exitosamente': 'Course successfully clonned',
    'Curso creado correctamente': 'Course created successfully',
    'Curso de capacitaci\xF3n': 'Course of capacitation',
    'Curso modificado correctamente': 'Course modified correctly',
    'Curso terminado con puntaje': 'Course finished with score: ',
    Curso_: 'Course_',
    Cursos: 'Courses',
    'Delete row': 'Delete row',
    Desactivado: 'Disabled',
    Desarrollo: 'Development',
    'Descargar PDF': 'Download PDF',
    'Descargar excel': 'Download Excel',
    Descripcion: 'Description',
    'Descripci\xF3n': 'Description',
    'Deseleccionar todos': 'Deselect all',
    'Detalle de SPACS': 'SPACS detail',
    'Detalle de la instancia': 'Instance detail',
    'Detalle de la instancia:': 'Instance detail:',
    'Detalle del SPAC:': 'SPAC detail:',
    'Detalle del colaborador': 'Collaborator detail:',
    'Detalle del colaborador:': 'Collaborator detail:',
    'Detalle del sector': 'Sector detail',
    'Detalle del sector:': 'Sector detail:',
    Documento: 'Document',
    'Documento/Código': 'Document/SPAC',
    Dominio: 'Domain',
    'Due\xF1o del sistema': 'System owner',
    Duracion: 'Duration',
    'Duraci\xF3n': 'Duration',
    'ERROR: El perfil no existe.': 'ERROR: This profile does not exist',
    'ERROR: Ya existe un perfil-colaborador con este perfil y colaborador':
      'ERROR: already exist a profile-collaborator with this profile and collaborator',
    'Planta Alberti': 'Alberti Plant',
    'Planta Santa Cruz': 'Santa Cruz Plant',
    'Planta Pagola': 'Pagola Plant',
    'Planta Pilar': 'Pilar Plant',
    Edit: 'Edit',
    'Editando curso': 'Editing course',
    Editar: 'Edit',
    'Editar requerimientos': 'Edit requirements',
    Editing: 'Editing',
    'En edicion': 'Editing',
    'El CWID ingresado ya se encuentra en uso': 'The CWID is already in use',
    'El archivo solicitado no existe': 'This requested file does not exist',
    'El nuevo puntaje obetenido sobreescribrir\xE1 el \xFAltimo obtenido':
      'The new score obtained will overwrite the last one obtained ',
    'El nuevo puntaje sobreescribrir\xE1 el \xFAltimo obtenido':
      'The new score will overwrite the last one obtained',
    Eliminado: 'Deleted',
    Empezada: 'Started',
    'En Edicion': 'Editing',
    'En Progreso': 'In Progress',
    'En ejecucion': 'In action',
    'En licencia': 'On licence',
    'En progreso': 'In progress',
    'En tiempo': 'On Time',
    'Error al procesar la solicitud':
      'ERROR: the request could not be processed',
    'Espa\xF1ol': 'Spanish',
    Estado: 'Status',
    'Estado del curso': 'Course status',
    'Este campo es obligatorio': 'This field is required',
    'Este colaborador no se encuentra activo o registrado en la base de datos':
      'This collaborator is not found active or registered in the database',
    'Est\xE1 a punto de clonar el curso': 'You are about to clone the course',
    'Est\xE1 por empezar el test {0}': 'The Test is about to begin {0}',
    'Experto Materia': 'Subject matter experto',
    'Expiraci\xF3n': 'Expiration',
    'Expiration:': 'Expiration:',
    Falta: [['0']],
    'Falta de tiempo debido a volumen de trabajo':
      'Lack of time due to workload',
    Fecha: 'Date',
    'Fecha de Actualizacion': 'Update date',
    'Fecha de Requerimiento': 'Requirement date',
    'Fecha de Vigencia': 'Validity date',
    'Fecha de actualizacion': 'Update date',
    'Fecha de expiraci\xF3n': 'Expiration date',
    'Fecha de ingreso': 'Onboard date',
    'Fecha de instancia': 'Instance date',
    'Fecha de realizacion': 'Completion date',
    'Fecha de vigencia': 'Validity date',
    'Fecha fin': 'Final date',
    'Fecha final': 'Final date',
    'Fecha inicial': 'Initial date',
    'Fecha inicio': 'Initial date',
    'Finalizaci\xF3n': 'Finished at',
    'Finalizaci\xF3n de curso': 'Course completion',
    Finalizada: 'Finished',
    Finalizar: 'Finish',
    'Finalizar edici\xF3n': 'Finish editing',
    Finished: 'Finished',
    Firma: 'Signature',
    Firmar: 'Sign',
    'Fomulario XMLS': 'XMLS form',
    Generar: 'Generar',
    'Generar requerimiento': 'Generate requirement',
    Gerencia: 'Management',
    'Gestion de capacitaciones': 'Capacitations Management',
    Grupo: 'Group',
    'Grupo HSE': 'HSE group',
    'Grupo ITPS': 'ITPS group',
    'Grupo QA': 'QA group',
    'Grupo capacitador': 'Trainer group',
    'Grupo colaborador': 'collaborator group',
    Hay: 'There is/are',
    Horario: 'Time',
    Cochabamba: 'Cochabamba',
    'Casa Central': 'Casa Central',
    'ID Instancia': 'ID Instance',
    'Imprimir examen': 'Print exam',
    'Imprimir reporte': 'Print assistants',
    'In progress': 'In progress',
    InPerson: 'Paper',
    InProgress: 'In Progress',
    Inactivo: 'Inactive',
    'Informaci\xF3n del curso': 'Course information',
    'Ingl\xE9s': 'English',
    'Ingrese sus credenciales para confirmar la operaci\xF3n':
      'Please enter your credentials to confirm operation',
    'Ingrese sus credenciales para firmar su asistencia':
      'Please, enter your credentials to sign your attendance',
    'Ingrese un email v\xE1lido': 'Enter a valid email',
    'Ingrese un n\xFAmero correcto': 'Enter a correct number',
    'Ingrese una fecha correcta': 'Enter a correct date',
    Iniciar: 'Start',
    'Iniciar sesi\xF3n': 'Login',
    Inicio: 'Inicio',
    Inscripto: 'Enrolled',
    Instance: 'instance',
    'Instance management': 'Instance management',
    Instances: 'Instances',
    'Instances by Sectors': 'Instances by sectors',
    'Instances by sectors': 'Instances by sectors',
    'Instances by spac': 'Instances by spac',
    Instancia: 'Instance',
    Instancias: 'Instances',
    'Instancias por capacitacion': 'Capacitation by instances',
    Instructor: 'Instructor',
    Instructors: 'Instructors',
    Intento: 'Attempt',
    'Invalid Date Format': 'Invalid Date Format',
    'Ir a la tabla choice': "Go to choice's table",
    'Ir al detalle': 'Go to detail',
    'La fecha de vigencia debe ser igual o mayor a la fecha actual':
      'Vigency date must be equals or greater than actual date',
    Legajo: 'Employee file',
    'Licencia M\xE9dica': 'Medical license',
    'Marque con un \u2714\uFE0F las respuestas correctas':
      'Mark the correct answers with a \u2714\uFE0F',
    Material: 'Material',
    Materiales: 'Materials',
    'Mi Tablero': 'My dashboard',
    'Mi tablero': 'My dashboard',
    'Módulo Reporting': 'Reporting module',
    Modalidad: 'Modality',
    'Modalidad:': 'Modality: ',
    Modality: 'Modality',
    'Modo de encriptacion': 'Encryption mode',
    Motivo: 'Reason',
    Multiple: 'Multiple',
    'M\xFAltiple': 'Multiple',
    No: 'No',
    'No Empezada': 'Not started',
    'No aplica': 'Does not apply',
    'No hay notificaciones.': 'No notifications.',
    'No se encontraron cursos correspondientes para ese perfil':
      'There are not courses with that profile',
    'No se encuentra realizado en tiempo': 'not performed in time',
    'No se ha podido autenticar al usuario correctamente - intente nuevamente m\xE1s tarde':
      'The user could not be authenticated correctly, please try again later',
    'No se puede finalizar un curso no aprobado':
      'it cannot finish an unapproved course',
    'No se puede loguear el usuario': 'No se puede loguear el usuario',
    Nombre: 'Name',
    'Nombre Curso': 'Course name',
    'Nombre del Curso': 'Courses name',
    'Nombre del PDF': "PDF's name",
    'Nombre del SPAC': 'SPAC name',
    'Nombre del Spac': 'SPAC name',
    'Nombre del asistente': 'Assistants name',
    'Nombre del curso': 'Course name',
    'Nombre del empleado': 'Collaborators name',
    'Nombre del perfil': "Profile's name",
    'Nombre del sector': 'Sectors name',
    'Nombre sector': 'Sectors name',
    'Not yet started': 'Not yet started',
    'Notificaciones via email': 'Email notifications',
    'Habilitar notificaciones por email': 'Enable email notifications',
    'Nro. de empleado responsable': 'Responsible employee number',
    'Numero de empleado': 'Employee number',
    Observacion: 'Observation',
    Obsolete: 'Obsolete',
    Obsoleto: 'Obsolete',
    Online: 'Online',
    'Política de contraseñas': 'Password policy',
    'Operacion terminada exitosamente': 'Operation successfully completed',
    Otros: 'Others',
    Papel: 'Paper',
    'Para acceder a la documentaci\xF3n externa, pulse el siguiente enlace:':
      'To access the external documentation, please click on the following link:',
    Parametros: 'Parameters',
    Password: 'Password',
    Pendiente: 'Pending',
    Perfil: 'Profile',
    'Perfil SPAC': 'Profile SPAC',
    'Perfil Spac': 'Profile SPAC',
    'Perfil-Colaborador': 'Profile-Collaborator',
    'Perfil-Curso': 'Profile-Course',
    'Perfil-Spac': 'Profile-SPAC',
    Perfiles: 'Profiles',
    'Perfiles Seleccionados': 'Selected profiles',
    Pictograma: 'PPPUP',
    Planta: 'Building',
    'Please enter your credentials to confirm operation':
      'Please enter your credentials to confirm operation',
    'Please provide a password': 'Please provide a password',
    'Poco tiempo entre creaci\xF3n del curso y vigencia del SOP':
      'Short period between course creation and SOP validity',
    'Por favor seleccione m\xE1ximo 25 sectores.':
      'Please select maximum 25 sectors.',
    Porcentaje: 'Percentage',
    Pregunta: 'Choice',
    Presente: 'Present',
    Procentaje: 'Procentaje',
    Produccion: 'Production',
    Profile: 'Profile',
    'Recomendado para el puerto 465 (SSL implícito).':
      'Recommended for port 465 (implicit SSL).',
    'Recomendado para el puerto 587. Requerido por la mayoría de los servidores modernos.':
      'Recommended for port 587. Required by most modern servers.',
    'Requerir Número': 'Require number',
    'Requerir Símbolo': 'Require symbol',
    'Bloquear secuencias obvias': 'Block obvious sequences',
    'Bloquear datos personales': 'Block personal data',
    'Longitud mínima': 'Minimum length',
    'Evitar reutilización de contraseñas': 'Prevent password reuse',
    'Profile General Spac': 'Profile General Spac',
    'Profile Spac': 'Profile SPAC',
    'Profile collaborator': 'Profile-collaborator',
    'Profile does not exist': 'Profile does not exist',
    'Profile-Collaborator': 'Profile-Collaborator',
    'Profile-Course': 'Profile-Course',
    'Profile-General': 'General Profile',
    Profiles: 'Profiles',
    Propietario: 'Owner',
    'Proveedor de sistemas': 'System provider',
    Puerto: 'Port',
    Puntaje: 'Score',
    'Puntaje m\xEDnimo': 'Minimum score',
    'Puntaje necesario': 'Necessary score',
    'Raz\xF3n tardanza': 'Late reason',
    ReValidado: 'Re validated',
    Reason: 'Reason',
    'Registro de firma': 'Signature registry',
    Reporte: 'Report',
    'Reporte - capacitaci\xF3n inicial': 'Report - initial training',
    'Reporte de integritdad de datos': 'Data integrity report',
    Requerimientos: 'Requirements',
    Requirement: 'Requirement',
    'Requirement does not exist': 'Requirement does not exist',
    Requirements: 'Requirements',
    Responsable: 'Responsible',
    Respuesta: 'Answer',
    Revision: 'Revision',
    Role: 'Role',
    'Ruta de materiales': 'Materials path',
    'Ruta del registro de firma': 'Signature record path',
    Rutas: 'Path',
    'SALIR DEL MODO TABLET': 'EXIT TABLET MODE',
    SPAC: 'SPAC',
    Salir: 'Exit',
    'Salir de modo tablet': 'Exit tablet mode',
    'Se encuentra realizado en tiempo': 'It was done on time',
    'Se encuentra vencido': 'It is expired',
    'Se guardar\xE1 el intento con puntaje 0.':
      'The attempt with a score of 0 will be saved.',
    Sector: 'Sector',
    Sectores: 'Sectors',
    'Seleccionar Perfiles': 'Select profiles',
    'Seleccionar m\xEDnimo una respuesta correcta.':
      'Select at least one correct answer.',
    'Seleccionar todos': 'Select all',
    'Server de LDAP': 'LDAP Server',
    'Servicio de IT': 'IT Service',
    Si: 'Yes',
    Siguiente: 'Next',
    Simple: 'Simple',
    'Sin Empezar': 'Not yet Started',
    'Sin empezar': 'Not started',
    Spac: 'SPAC',
    Stage: 'Instance',
    Stages: 'Instances',
    'Tabla de integrity': 'Integrity table',
    Tablet: 'Tablet',
    Terminado: 'Finished',
    'Tiempo de expiraci\xF3n de capacitaciones iniciales (en d\xEDas)':
      'Expiration time for initial training (in days)',
    Time: 'Time',
    Tipo: 'Type',
    'Tipo de curso': 'Course type',
    'Tipo de encriptacion': 'Encryption type',
    Todos: 'All',
    'Tomar curso': 'Take course',
    Trainer: 'Trainer',
    Turn: 'Shift',
    Turno: 'Shift',
    Turnos: 'Shifts',
    Turns: 'Shifts',
    'T\xEDtulo': 'Title',
    'URL en el email': 'URL in email',
    'Ultima contrase\xF1a': 'Last Password',
    'Ultimo inicio de sesion': 'Last login',
    'Una vez finalizado el curso ya no se podr\xE1 editar y se crear\xE1n las instancias online.':
      'Once the course is finished, it can no longer be edited and the online instances will be created.',
    User: 'User',
    Users: 'Users',
    'Modo anónimo': 'Anonymous mode',
    'Usar modo anónimo': 'Use anonymous mode',
    'Usar STARTTLS': 'Use STARTTLS',
    'Usar SSL': 'Use SSL',
    'Usted tiene': 'You have',
    'Usted tiene {0} curso/s que estan por vencer':
      'You have {0} course/s that are about to expire',
    'Usted tiene {value} curso/s que estan por vencer':
      'You have {value} course/s that are about to expire',
    Usuario: 'User',
    'SMTP Usuario': 'SMTP user',
    'SMTP Contraseña': 'SMTP password',
    'Puerto SMTP': 'SMTP port',
    'Servidor SMTP': 'SMTP server',
    'Dirección remitente (From)': 'Sender address (From)',
    'Se recomienda activar STARTTLS cuando se usa autenticación SMTP.':
      'It is recommended to enable STARTTLS when SMTP authentication is used.',
    'Usuario y/o contrase\xF1a incorrectos': 'User or password incorrect',
    Vacaciones: 'Holidays',
    Valid: 'Valid',
    Validado: 'Validated',
    'Validar dominio': 'Validate domain',
    'Validar grupo': 'Validate group',
    Valido: 'Valid',
    'Vence el:': 'Expires:',
    'Vence el: ': 'Expires: ',
    'Vence en': 'Expire in',
    'Vence hoy': 'Expire today',
    'Vence ma\xF1ana': 'Expire tomorrow',
    Vencido: 'Expired',
    'Vencimiento de la instancia': 'Instance expiration',
    'Vencimiento:': 'Expiration:',
    Ver: 'Watch',
    'Ver todos': 'See all',
    'Versi\xF3n': 'Version',
    'Versi\xF3n tablet': 'Tablet version',
    Vigente: 'Valid',
    Visualizar: 'Visualize',
    Volver: 'Back',
    'Cambiar fecha de expiración': 'Change expiration date',
    'Volver a realizar cuestionario': 'Try again to do the Questionnaire',
    'Volver al material': 'Back to material',
    '_Asistencia.pdf': '_Assistance.pdf',
    '_CapacitacionInicial.pdf': '_InitialCapacitation.pdf',
    '_Test.pdf': '_Test.pdf',
    '_reporte.pdf': '_Report.pdf',
    'al curso': ' to the course',
    almostDueDate: '> 1 and \u2264 7 days',
    'capacitaciones pendientes para': 'pending capacitacions for',
    'collaborator does not exist': 'collaborator does not exist',
    'content does not exist': 'content does not exist',
    'course does not exist': 'course does not exist',
    'curso/s que estan por vencer': 'course/s that are about to expire',
    'curso/s que estan por vencer o ya est\xE1n vencidos':
      'courses to expire or already expired',
    'cursos por vencer.': 'courses to expire.',
    'dia/s para que venza': ' day/s to expire',
    dued: '\u2264 0 days (EXPIRED)',
    'd\xEDas': 'days',
    'editado correctamente': 'Modified correctly',
    finished: 'Finished',
    finishedDued: 'Finished dued',
    finishedOnTime: 'Finished on time',
    nearDueDate: '> 7 and \u2264 15 days',
    onTime: '> 15 days',
    pending: 'Pending',
    'sector does not exist': 'sector does not exist',
    'ultimo login': 'Last login',
    'values is empty': 'values is empty',
    'values null': 'values null',
    '{0}': '{0}',
    '\xBFDesea finalizar la instancia? Una vez aceptado la instancia estara finalizada y no se podra seguir editando':
      'Do you want to finish the instance? Once accepted the instance will be finished and it will not be able to continue editin',
    '\xBFDesea volver a realizarlo?': 'Do you want to do it again?',
    '\xBFDesesa volver a realizarlo?': 'Do you want to do it again?',
    '\xBFEst\xE1 seguro que desea salir del curso?':
      '\xBFAre you sure that you whant to exit the course?',
    '\xDAltimo puntaje aprobado exitosamente':
      'The last score successfully passed',
    '\xDAltimo puntaje obtenido:': 'last score obtained: ',
  },
};
